import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './SnapPhone.module.less';
import phoneMockup from './mockup.png';

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
    };
  }
  onClickVideo = () => {
    if (this.video.ended) {
      this.setState({
        playing: true,
      });
      this.video.play();
    } else {
      if (this.state.playing) {
        this.video.pause();
      } else {
        this.video.play();
      }
      this.setState({
        playing: !this.state.playing,
      });
    }
  }
  onEndedVideo = () => {
    this.setState({
      playing: false,
    });
  }
  render() {
    return (
      <div className={styles.snapContainer}>
        {this.props.withPhone &&
          <img src={phoneMockup} className={styles.phoneMockup} />
        }
        <div className={classNames(styles.videoContainer, { [styles.isPlaying]: this.state.playing })} onClick={this.onClickVideo}>
          <div className={styles.playButton}></div>
          <video src={this.props.url} onEnded={this.onEndedVideo} ref={(video) => { this.video = video }} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SnapPhone/SnapPhone.jsx